'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useMemo, useRef, useState } from 'react';
import Multilingual from '../../global/Multilingual';
import { cx } from '@/src/styles/stylebook';
import { useRevealOnScroll } from '@/src/hooks/useRevealOnScroll';
// Type guard to check if item has title property (MenuItem type)
const isMenuItem = item => {
  return item && typeof item.title !== 'undefined';
};
const StickyMenu = props => {
  const {
    data,
    year
  } = props;
  const pathname = usePathname();
  const [currentItem, setCurrentItem] = useState(null);
  const [showMenu, setShowMenu] = useState(true);
  const [isRelativePath, setIsRelativePath] = useState(false);
  const hiddenMenuPaths = ['/community/notice/', '/community/press/'];
  const relativePaths = ['/submit/faq', '/programs/events', '/screening/places', '/programs/sections', '/screening/schedule', '/submit/submission'];
  const scrollRevealPaths = ['/films/', '/community/notice/', '/community/press/'];
  const menuPathname = useMemo(() => {
    if (pathname.startsWith('/films/')) {
      return '/programs/sections';
    }
    if (pathname.startsWith('/community/notice/')) {
      return '/community/notice';
    }
    if (pathname.startsWith('/community/press/')) {
      return '/community/press';
    }
    if (pathname.startsWith('/submit/inquiry') || pathname.startsWith('/submit/result') || pathname.startsWith('/submit/submission')) {
      return '/submit/rules';
    }
    return pathname;
  }, [pathname]);
  const shouldUseScrollReveal = useMemo(() => scrollRevealPaths.some(path => pathname.startsWith(path)), [pathname]);
  const containerRef = useRef(null);
  const {
    isRevealed
  } = useRevealOnScroll({
    targetRef: containerRef,
    enabled: shouldUseScrollReveal,
    margin: 0
  });
  useEffect(() => {
    const matchedItems = data.filter(item => menuPathname.includes(item.slug?.current || 'No Results'));
    if (matchedItems.length > 0 && matchedItems[0].subMenu && matchedItems[0].subMenu.length > 0) {
      // 또는 페이지 내용의 index
      setCurrentItem(matchedItems[0]);
    } else {
      setCurrentItem(null);
    }
  }, [menuPathname, data]);
  useEffect(() => {
    setIsRelativePath(relativePaths.some(path_0 => pathname.includes(path_0)));

    // 상세 페이지인지 확인: 부모 경로로 시작하면서 그 이후에 추가 경로가 있는 경우
    // 단, scrollRevealPaths에 포함된 경로들은 메뉴를 숨기지 않고 스크롤 기반으로 표시
    const shouldHideMenu = hiddenMenuPaths.some(basePath => {
      const parentPath = basePath.slice(0, -1); // '/community/notice/' → '/community/notice'
      const isDetailPage = pathname.startsWith(basePath) && pathname.length > parentPath.length;
      const isScrollRevealPath = scrollRevealPaths.some(scrollPath => pathname.startsWith(scrollPath));
      return isDetailPage && !isScrollRevealPath;
    });
    setShowMenu(!shouldHideMenu);
  }, [pathname]);
  if (!currentItem || !currentItem.subMenu || currentItem.subMenu.length === 0) {
    return null;
  }
  return <div ref={containerRef} className={cx('h5 px-marg pointer-events-none sticky top-0 z-50 flex h-[5.8125rem] flex-col justify-end font-bold',
  // mobile
  'scroll-hide max-md:pb-gutter max-md:hidden max-md:w-full max-md:overflow-x-auto max-md:px-0', !showMenu ? 'hidden' : '', isRelativePath ? '!relative' : '')} data-layer="StickyMenu">
      <ul className={cx('gap-gutter max-md:px-marg scroll-hide m-0 flex list-none overflow-x-auto leading-tight transition-opacity duration-300', shouldUseScrollReveal ? isRevealed ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0' : 'pointer-events-auto')}>
        {currentItem.subMenu.filter(isMenuItem) // Only render items that have title property
      .map((item_0, index) => <Link key={`${item_0.slug?.current}-${index}`} href={`/${currentItem.slug?.current}/${item_0.slug?.current}`} className={cx('shrink-0 whitespace-pre', menuPathname.includes(`/${currentItem.slug?.current}/${item_0.slug?.current}`) ? '' : 'opacity-30')}>
              <Multilingual>
                {`${item_0.slug?.current === 'overview' ? `${year} ` : ''}${item_0.title}`}
              </Multilingual>
            </Link>)}
      </ul>
    </div>;
};
export default StickyMenu;